import { RouteComponentProps } from "@reach/router";
import React from "react";

// Not found has a default route for router setup
const NotFound: React.FC<RouteComponentProps> = () => (
  <div className="NotFound" style={{ minHeight: 400 }}>
    <h1 style={{ textAlign: "center" }}>This page can not be found</h1>
  </div>
);

export default NotFound;
